<template>
  <div class="isolate">
    <Iphone17EventPage v-if="isIphone17EventPage" />
    <ProductJapan v-else-if="isJapanProductPage" />
    <Product v-else />
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRuntimeConfig } from '#imports'
import { computed, defineAsyncComponent } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

const Product = defineAsyncComponent(
  () => import('~/scopes/product/pages/Product.vue'),
)
const ProductJapan = defineAsyncComponent(
  () => import('~/scopes/product/pages/Product-JP/Product-JP.vue'),
)
const Iphone17EventPage = defineAsyncComponent(
  () =>
    import('~/scopes/product-core/pages/Iphone17EventPage/Iphone17EventPage.vue'),
)

const route = useRoute()
const { market } = useMarketplace()
const { FF_PRODUCT_PAGE_IPHONE_17_EVENT_PAGE = '' } = useRuntimeConfig().public

const isJapanProductPage = computed(
  () => market.countryCode === MarketCountryCode.JP,
)

const isIphone17EventPage = computed(() => {
  return (
    route.params.slug === 'samsung-s26' &&
    FF_PRODUCT_PAGE_IPHONE_17_EVENT_PAGE.includes(market.countryCode)
  )
})
</script>
